export const DEFAULT = 'default';
export const DOMAIN = 'domain';
export const TRIAL = 'trial';
